import { useState } from "react";
import { MetadataForm } from "@/components/MetadataForm";
import { MetadataValidator } from "@/components/MetadataValidator";
import { MetadataPreview } from "@/components/MetadataPreview";

const Index = () => {
  const [metadata, setMetadata] = useState<Record<string, any> | null>(null);

  const handleSubmit = (formData: Record<string, any>) => {
    setMetadata(formData);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/20 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-3">
            Metadata Intelligence
          </h1>
          <p className="text-lg text-muted-foreground">
            Universal metadata engine for music, media, and cultural assets
          </p>
        </div>

        {/* Form Section */}
        <div className="flex flex-col gap-8">
          <div className="flex justify-center">
            <MetadataForm onSubmit={handleSubmit} />
          </div>

          {/* Results Section */}
          {metadata && (
            <>
              <div className="flex justify-center">
                <MetadataValidator metadata={metadata} />
              </div>
              <div className="flex justify-center">
                <MetadataPreview metadata={metadata} />
              </div>
            </>
          )}
        </div>

        {/* Features Grid */}
        {!metadata && (
          <div className="mt-16 grid md:grid-cols-3 gap-6">
            {[
              {
                title: "GRAMMY Compatible",
                description: "Industry-standard ISRC code validation",
              },
              {
                title: "Multi-Platform",
                description: "Support for Luminate, Discogs, SoundOn & more",
              },
              {
                title: "Real-time Validation",
                description: "Instant compatibility checks across platforms",
              },
            ].map((feature, idx) => (
              <div
                key={idx}
                className="text-center p-6 rounded-lg border border-border bg-card hover:bg-muted/50 transition-colors"
              >
                <h3 className="font-semibold mb-2">{feature.title}</h3>
                <p className="text-sm text-muted-foreground">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Index;